module.exports = __webpack_public_path__ + "static/media/valor2_2.25e3b8cb.png";